import { BrowserRouter, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import SeoHead from "./components/SeoHead";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function DomainRedirect() {
  useEffect(() => {
    const host = window.location.hostname;
    if (host === "businesstraining.by" || host === "www.businesstraining.by") {
      window.location.href =
        "https://business-training.by" +
        window.location.pathname +
        window.location.search +
        window.location.hash;
    }
  }, []);
  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <DomainRedirect />
        <SeoHead />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;